import AuthorizationCheckPage from './AuthorizationCheckPage'

export default AuthorizationCheckPage
